import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { ProductContext } from "../App";
import AddSoldOutOrder from "../components/popups/AddSoldOutOrder";

function SoldoutOrders() {
  const { setIsLoading, alert, setAlert, setConfirmDialogue, confirmDialogue } =
    useContext(ProductContext);
  const [addSoldOutOrder, setAddSoldOutOrder] = useState({
    order: {},
    isOpen: false,
  });
  const [extraOrders, setExtraOrders] = useState([]);

  const load = () => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_SERVER_DOMAIN}/extra-order`)
      .then((res) => {
        setExtraOrders(res.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setAlert({
          isOpen: true,
          message: "Something Went Wrong",
          type: "danger",
        });
        setIsLoading(false);
      });
    setTimeout(() => {
      setAlert({ ...alert, isOpen: false });
    }, 5000);
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line
  }, []);

  const deleteHandle = (id) => {
    setIsLoading(true);
    axios
      .delete(`${process.env.REACT_APP_SERVER_DOMAIN}/extra-order/${id}`)
      .then((res) => {
        setAlert({
          isOpen: true,
          message: "Order Deleted",
          type: "success",
        });
        load();
        setIsLoading(false);
      })
      .catch((err) => {
        setAlert({
          isOpen: true,
          message: "Something Went Wrong",
          type: "danger",
        });
        setIsLoading(false);
      });
    setTimeout(() => {
      setAlert({ ...alert, isOpen: false });
    }, 5000);
    setConfirmDialogue({ ...confirmDialogue, isOpen: false });
  };

  return (
    <div>
      <AddSoldOutOrder
        addSoldOutOrder={addSoldOutOrder}
        setAddSoldOutOrder={setAddSoldOutOrder}
      />
      <h3 className="text-center my-5">Sold Out Orders</h3>
      <div className="mb-5 d-flex align-items-center justify-content-center">
        <div className="stock-table">
          <table className="table-bordered mx-3 my-3">
            <thead>
              <tr>
                <th>Name</th>
                <th>Instagram Id</th>
                <th>Contact</th>
                <th>Address</th>
                <th>Item</th>
                <th>Options</th>
              </tr>
            </thead>
            <tbody>
              {extraOrders?.map((order, i) => {
                return (
                  <tr key={i}>
                    <td>{order?.customerName || "-"}</td>
                    <td>{order?.instaId || "-"}</td>
                    <td>
                      <a href={`tel:${order?.contact}`}>
                        {order?.contact || "-"}
                      </a>
                    </td>
                    <td>{order?.address || "-"}</td>
                    <td>{order?.itemName || "-"}</td>
                    <td className="action">
                      <i
                        onClick={() => {
                          setAddSoldOutOrder({
                            order: order,
                            isOpen: true,
                            reload: () => {
                              load();
                            },
                          });
                        }}
                        className="fa-solid fa-file-pen mx-2 edit"
                      ></i>
                      <i
                        onClick={() => {
                          setConfirmDialogue({
                            isOpen: true,
                            message:
                              "Are you sure you want to delete this order?",
                            submitHandle: () => {
                              deleteHandle(order._id);
                            },
                          });
                        }}
                        className="fa-solid fa-trash delete mx-2"
                      ></i>
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td colSpan={6} className="text-center">
                  <button
                    onClick={() => {
                      setAddSoldOutOrder({
                        order: {},
                        isOpen: true,
                        reload: () => {
                          load();
                        },
                      });
                    }}
                    className="btn btn-secondary"
                  >
                    Add Order
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default SoldoutOrders;
